import MCR from "monocart-coverage-reports";

export const coverageReport = MCR({
    outputDir: "./playwright-coverage",
    reports: ["v8", "console-summary", "v8-json"],
    filter: {
        "**/ux-ui.css": false,
        "**/dist/themes/**": false,
        "**/node_modules/**": false,
        "**/~dev-server": false,
        "src/globals/**": false,
        "src/utils/**": false,
        "ux-utils/**": false,
        "**/dayjs.min*": false,
        "**/test": false,
        "**/*.e2e.html": false,
        "**/*lazy-browser-entrypoint*": false,
        "@stencil*/**": false,
        "src/**": true,
        "**/**": true
    }
});
